import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'orderby', standalone: false })
export class OrderByFilterPipe implements PipeTransform {
    transform(values: any[], key?: string, reverse?: boolean, secondaryKey?: string) {
        if (!Array.isArray(values) || values.length <= 0) {
            return null;
        }
        if (key == "")
            return values;
        if (key && typeof values[0][key] === "string")
            return this.sortString(values, key, reverse, secondaryKey);

        return this.sort(values, key, reverse);
    }

    private sortString(value: { [key: string]: any }[], key?: string, reverse?: boolean, secondaryKey?: string): any[] {
        const array: any[] = value.sort((a: any, b: any) => {
            let cmp = (key && (a[key] == undefined ? "" : a[key]).localeCompare(b[key] == undefined ? "" : b[key])) || 0;
            if (cmp == 0 && secondaryKey) {
                let secCmp: number
                if (secondaryKey && typeof a[secondaryKey] === "string")
                    secCmp = (a[secondaryKey] == undefined ? "" : a[secondaryKey]).localeCompare(b[secondaryKey] == undefined ? "" : b[secondaryKey])
                else
                    secCmp = (a[secondaryKey] == undefined ? "" : a[secondaryKey]) > (b[secondaryKey] == undefined ? "" : b[secondaryKey]) ? 1 : ((a[secondaryKey] == undefined ? "" : a[secondaryKey]) < (b[secondaryKey] == undefined ? "" : b[secondaryKey]) ? -1 : 0)
                return reverse ? secCmp * -1 : secCmp
            }
            return reverse ? cmp * -1 : cmp
        })
        // if (reverse) {
        //     return array.reverse();
        // }
        return array;
    }

    private sort(value: any[], key?: any, reverse?: boolean, secondaryKey?: string): any[] {

        const array: any[] = value.sort((a: any, b: any): number => {
            let cmp = (a[key] == undefined ? "" : a[key]) > (b[key] == undefined ? "" : b[key]) ? 1 : ((a[key] == undefined ? "" : a[key]) < (b[key] == undefined ? "" : b[key]) ? -1 : 0)
            if (cmp == 0 && secondaryKey) {
                let secCmp: number
                if (typeof a[secondaryKey] === "string")
                    secCmp = (a[secondaryKey] == undefined ? "" : a[secondaryKey]).localeCompare(b[secondaryKey] == undefined ? "" : b[secondaryKey])
                else
                    secCmp = (a[secondaryKey] == undefined ? "" : a[secondaryKey]) > (b[secondaryKey] == undefined ? "" : b[secondaryKey]) ? 1 : ((a[secondaryKey] == undefined ? "" : a[secondaryKey]) < (b[secondaryKey] == undefined ? "" : b[secondaryKey]) ? -1 : 0)
                return reverse ? secCmp * -1 : secCmp
            }
            return reverse ? cmp * -1 : cmp
        })

        // if (reverse) {
        //     return array.reverse();
        // }

        return array;
    }

    private getValue(object: any, key: string[]) {
        for (let i = 0, n = key.length; i < n; ++i) {
            const k = key[i];
            if (!(k in object)) {
                return;
            }

            object = object[k];
        }
        return object;
    }
}

// undefined : typeof instance === "undefined"
// Boolean : typeof instance === "boolean"
// Number : typeof instance === "number"
// String : typeof instance === "string"
// BigInt : typeof instance === "bigint"
// Symbol : typeof instance === "symbol"

// this.array.sort((a,b)=>{
//     a= a[colName].toLowerCase();
//     b= b[colName].toLowerCase();
//     return a.localeCompare(b) * this.sortDir;
//   });